import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Luggage04 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="luggage-04">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.47681 5.27749C9.44576 5.30722 9.4375 5.33558 9.4375 5.35892V6.63242H13.9688V5.35892C13.9688 5.33558 13.9605 5.30722 13.9294 5.27749C13.8976 5.24703 13.8473 5.22217 13.7812 5.22217H9.625C9.55894 5.22217 9.50863 5.24703 9.47681 5.27749ZM15.9688 6.63242V5.35892C15.9688 4.13811 14.9478 3.22217 13.7812 3.22217H9.625C8.45849 3.22217 7.4375 4.13811 7.4375 5.35892V6.63242H4.875C3.05265 6.63242 1.5 8.05731 1.5 9.90593V16.7264C1.5 18.5751 3.05265 19.9999 4.875 19.9999H19.125C20.9474 19.9999 22.5 18.5751 22.5 16.7264V9.90593C22.5 8.05731 20.9474 6.63242 19.125 6.63242H15.9688ZM4.875 8.63242C4.074 8.63242 3.5 9.2433 3.5 9.90593V16.7264C3.5 17.3891 4.074 17.9999 4.875 17.9999H19.125C19.926 17.9999 20.5 17.3891 20.5 16.7264V9.90593C20.5 9.2433 19.926 8.63242 19.125 8.63242H4.875Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
